<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M11.6198 6.17028C11.4848 6.30798 11.4092 6.49311 11.4092 6.68593C11.4092 6.87875 11.4848 7.06389 11.6198 7.20159L12.7984 8.38023C12.9361 8.5152 13.1212 8.5908 13.3141 8.5908C13.5069 8.5908 13.692 8.5152 13.8297 8.38023L16.198 6.01193C16.3957 5.81425 16.7292 5.87638 16.8102 6.14395C17.013 6.81331 17.0548 7.52406 16.9284 8.21753C16.7674 9.10145 16.3408 9.91529 15.7054 10.5506C15.0701 11.1859 14.2563 11.6125 13.3724 11.7736C12.4885 11.9346 11.5765 11.8225 10.7579 11.4521L5.66764 16.5423C5.37459 16.8354 4.97712 17 4.56267 17C4.14822 17 3.75075 16.8354 3.4577 16.5423C3.16464 16.2492 3 15.8518 3 15.4373C3 15.0229 3.16464 14.6254 3.4577 14.3324L8.54794 9.24211C8.17753 8.42355 8.06538 7.51154 8.22643 6.62763C8.38748 5.74372 8.81409 4.92987 9.4494 4.29456C10.0847 3.65925 10.8986 3.23264 11.7825 3.07159C12.4759 2.94524 13.1867 2.98705 13.8561 3.1898C14.1236 3.27084 14.1858 3.6043 13.9881 3.80198L11.6271 6.16291L11.6198 6.17028Z" fill="#202830"/>
    </svg>
</template>

<script>
export default {
    name: 'IconRepair',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
